module.exports = __webpack_public_path__ + "img/D0006.73f30a4a.svg";